(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let enabled = !preference.matches && !navigator.connection?.saveData;
  let chosen = false;
  const inView = new Set();
  const observed = new WeakSet();
  const selector = 'video[data-bf-src]';

  function sync(video) {
    if (!enabled || document.hidden || !inView.has(video)) {
      video.pause();
      return;
    }
    if (!video.src) video.src = video.dataset.bfSrc;
    video.muted = true;
    video.play().catch(() => {});
  }

  function update() {
    document.querySelectorAll('[data-bf-motion]').forEach(button => {
      button.hidden = false;
      button.querySelector('[data-motion-icon]').textContent = enabled ? 'Ⅱ' : '▷';
      button.querySelector('[data-motion-text]').textContent = enabled ? 'Pause videos' : 'Play videos';
    });
    document.querySelectorAll(selector).forEach(sync);
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) inView.add(target);
      else inView.delete(target);
      sync(target);
    });
  }, { threshold: 0.08 });

  function connect(root) {
    root.querySelectorAll(selector).forEach(video => {
      if (observed.has(video)) return;
      observed.add(video);
      video.addEventListener('playing', () => video.classList.add('bf-film-started'));
      video.addEventListener('error', () => video.classList.remove('bf-film-started'));
      observer.observe(video);
    });
    update();
  }

  document.addEventListener('click', event => {
    if (!event.target.closest('[data-bf-motion]')) return;
    chosen = true;
    enabled = !enabled;
    update();
  });
  preference.addEventListener('change', () => {
    if (!chosen) { enabled = !preference.matches && !navigator.connection?.saveData; update(); }
  });
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', event => connect(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(video => {
      observer.unobserve(video);
      inView.delete(video);
      video.pause();
    });
  });
  connect(document);
})();